import { useNavigate, useParams } from 'react-router-dom';

export default function TrackOrder() {
  const navigate = useNavigate();
  const { orderId } = useParams();

  const orderDetails = {
    id: orderId || '#ORD-2024-001',
    storeName: 'بقالة الأمانة',
    storePhone: '+966 11 234 5678',
    deliveryTime: '15-20 دقيقة',
    total: 42.50,
    address: 'شارع الملك فهد، حي النخيل، الرياض',
    driverName: 'أحمد محمد',
    driverPhone: '+966 50 987 6543',
    items: [
      { name: 'طماطم طازجة', quantity: 2, unit: 'كيلو' },
      { name: 'تفاح أحمر', quantity: 1, unit: 'كيلو' },
      { name: 'حليب طازج', quantity: 3, unit: 'لتر' }
    ]
  };

  const trackingSteps = [
    {
      title: 'تم تأكيد الطلب',
      time: '2:30 م',
      completed: true,
      icon: 'ri-check-line'
    },
    {
      title: 'جاري تحضير الطلب',
      time: '2:35 م',
      completed: true,
      icon: 'ri-restaurant-line'
    },
    {
      title: 'تم تسليم الطلب للسائق',
      time: '2:45 م',
      completed: true,
      icon: 'ri-truck-line'
    },
    {
      title: 'في الطريق إليك',
      time: 'الآن',
      completed: false,
      current: true,
      icon: 'ri-map-pin-line'
    },
    {
      title: 'تم التوصيل',
      time: '',
      completed: false,
      icon: 'ri-home-line'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* الهيدر */}
      <div className="bg-white shadow-sm">
        <div className="flex items-center justify-between p-4 pt-12">
          <button onClick={() => navigate(-1)} className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
          <h1 className="text-lg font-bold">تتبع الطلب</h1>
          <div className="w-10"></div>
        </div>
      </div>

      <div className="px-4 mt-4 space-y-4">
        {/* معلومات الطلب */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <div className="flex items-center justify-between mb-3">
            <div>
              <h3 className="font-bold text-gray-800">{orderDetails.storeName}</h3>
              <p className="text-sm text-gray-500">رقم الطلب: {orderDetails.id}</p>
            </div>
            <div className="text-left">
              <p className="font-bold text-green-600">{orderDetails.total} ر.س</p>
              <p className="text-sm text-gray-500">{orderDetails.deliveryTime}</p>
            </div>
          </div>
          
          <div className="bg-green-50 border border-green-200 rounded-lg p-3">
            <div className="flex items-center space-x-2 space-x-reverse">
              <i className="ri-time-line text-green-600"></i>
              <span className="text-green-700 font-medium">الوصول المتوقع: 15-20 دقيقة</span>
            </div>
          </div>
        </div>

        {/* الخريطة */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <div className="h-48 bg-gradient-to-br from-green-100 to-blue-100 relative">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3624.0!2d46.6753!3d24.7136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDQyJzQ5LjAiTiA0NsKwNDAnMzEuMSJF!5e0!3m2!1sen!2ssa!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
            <div className="absolute top-4 left-4 bg-white rounded-lg px-3 py-2 shadow-sm">
              <div className="flex items-center space-x-2 space-x-reverse">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-sm font-medium">السائق في الطريق</span>
              </div>
            </div>
          </div>
        </div>

        {/* معلومات السائق */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <h3 className="font-medium text-gray-800 mb-3">معلومات السائق</h3>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3 space-x-reverse">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <i className="ri-user-line text-green-600 text-xl"></i>
              </div>
              <div>
                <h4 className="font-medium text-gray-800">{orderDetails.driverName}</h4>
                <p className="text-sm text-gray-500">سائق التوصيل</p>
              </div>
            </div>
            <button className="w-10 h-10 bg-green-500 text-white rounded-full flex items-center justify-center">
              <i className="ri-phone-line text-lg"></i>
            </button>
          </div>
        </div>

        {/* تتبع الطلب */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <h3 className="font-medium text-gray-800 mb-4">تتبع الطلب</h3>
          
          <div className="space-y-4">
            {trackingSteps.map((step, index) => (
              <div key={index} className="flex items-start space-x-3 space-x-reverse">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  step.completed 
                    ? 'bg-green-500 text-white' 
                    : step.current 
                    ? 'bg-blue-500 text-white' 
                    : 'bg-gray-200 text-gray-400'
                }`}>
                  <i className={`${step.icon} text-sm`}></i>
                </div>
                <div className="flex-1">
                  <h4 className={`font-medium ${
                    step.completed || step.current ? 'text-gray-800' : 'text-gray-400'
                  }`}>
                    {step.title}
                  </h4>
                  {step.time && (
                    <p className="text-sm text-gray-500">{step.time}</p>
                  )}
                </div>
                {step.current && (
                  <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* تفاصيل الطلب */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <h3 className="font-medium text-gray-800 mb-3">تفاصيل الطلب</h3>
          
          <div className="space-y-2 mb-4">
            {orderDetails.items.map((item, index) => (
              <div key={index} className="flex justify-between text-sm">
                <span className="text-gray-600">{item.name}</span>
                <span className="text-gray-800">{item.quantity} {item.unit}</span>
              </div>
            ))}
          </div>
          
          <div className="border-t border-gray-100 pt-3">
            <div className="flex items-center space-x-2 space-x-reverse mb-2">
              <i className="ri-map-pin-line text-gray-400"></i>
              <span className="text-sm text-gray-600">عنوان التوصيل:</span>
            </div>
            <p className="text-sm text-gray-800 mr-6">{orderDetails.address}</p>
          </div>
        </div>

        {/* أزرار الإجراءات */}
        <div className="flex space-x-3 space-x-reverse">
          <button className="flex-1 bg-green-500 text-white py-3 rounded-lg font-medium">
            اتصال بالمتجر
          </button>
          <button className="flex-1 border border-gray-200 text-gray-600 py-3 rounded-lg font-medium">
            إلغاء الطلب
          </button>
        </div>
      </div>

      {/* شريط التنقل السفلي */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
        <div className="grid grid-cols-4 h-16">
          <button 
            onClick={() => navigate('/home')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-home-line text-xl mb-1"></i>
            <span className="text-xs">الرئيسية</span>
          </button>
          <button className="flex flex-col items-center justify-center text-gray-400">
            <i className="ri-search-line text-xl mb-1"></i>
            <span className="text-xs">البحث</span>
          </button>
          <button 
            onClick={() => navigate('/cart')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-shopping-cart-line text-xl mb-1"></i>
            <span className="text-xs">السلة</span>
          </button>
          <button 
            onClick={() => navigate('/orders')}
            className="flex flex-col items-center justify-center text-green-500"
          >
            <i className="ri-file-list-fill text-xl mb-1"></i>
            <span className="text-xs">طلباتي</span>
          </button>
        </div>
      </div>
    </div>
  );
}